import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets';
import { createServiceProvider } from '../util';

export default createServiceProvider({
  ...getServiceProvider('postscript'),
  avatarPath: avatars.postscript,
  logoPath: logos.postscript,
  hasConnectionStatus: false
});
